import {useQuery} from 'react-query'
import { api } from './base'

export const useQueryTeams = () => useQuery<any> (
  [
    'rdac/teams', 
  ],
  async ({signal}) => {
    const result = await api.get('/auth/team', {
      signal,
    })
    return result?.data
  },
  {keepPreviousData: true}
)
